import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

export interface Plan {
  _id: string;
  name: string;
  price: number;
  documents: number;
  users: number;
  features: string[];
  isActive: boolean;
  description?: string;
  createdAt?: string;
  updatedAt?: string;
  __v?: number;
}

export interface EstampClientConfigResponse {
  data?: {
    firstParty?: string | null;
  };
}

@Injectable({
  providedIn: 'root'
})
export class AccountService {
  private apiUrl = '';


  constructor(private http: HttpClient) { }

  getCustomerProfile() {
    return this.http.get(`${this.apiUrl}/admin/customers/profile/me`)
  }

  getEstampCustomerProfile() {
    return this.http.get(`${this.apiUrl}/bulk-estamp/client`)
  }

  getEstampClientConfig(clientEmail: string): Observable<EstampClientConfigResponse> {
    const encodedEmail = encodeURIComponent(clientEmail.trim());
    return this.http.get<EstampClientConfigResponse>(
      `${this.apiUrl}/bulk-estamp/admin/client/${encodedEmail}/config`
    );
  }

  updateProfile(data: any, customerId: string): any {
    return this.http.patch(`${this.apiUrl}/admin/customers/${customerId}/profile`, data)
  }

  updatePassword(data: any): any {
    return this.http.post(`${this.apiUrl}/admin/customers/profile/change-password`, data);
  }

  updateNotification(data: any, customerId: string): any {
    return this.http.patch(`${this.apiUrl}/admin/customers/${customerId}/notifications`, data);
  }

  getPlans(): Observable<Plan[]> {
    return this.http.get<Plan[]>(`${this.apiUrl}/plans`);
  }

  saveBranding(customerId: string, formData: any) {
    return this.http.patch(
      `${this.apiUrl}/admin/customers/${customerId}/branding`,
      formData
    );
  }

  estampRequest() {
    return this.http.patch(
      `${this.apiUrl}/bulk-estamp/client/estamp-activation/request`, {}
    );
  }

}
